import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWesternSahara = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1683_4550)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0H20V10H0V0Z",
				fill: "#000001"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 10H20V20H0V10Z",
				fill: "#007A3D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 6H20V14H0V6Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0L10 10L0 20V0Z",
				fill: "#C4111B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2344 12.7357C16.7453 12.7357 17.9701 11.5109 17.9701 9.99999C17.9701 8.4891 16.7453 7.26428 15.2344 7.26428C13.7235 7.26428 12.4987 8.4891 12.4987 9.99999C12.4987 11.5109 13.7235 12.7357 15.2344 12.7357Z",
				fill: "#C4111B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.2598 12.7357C17.7706 12.7357 18.9955 11.5109 18.9955 9.99999C18.9955 8.4891 17.7706 7.26428 16.2598 7.26428C14.7489 7.26428 13.524 8.4891 13.524 9.99999C13.524 11.5109 14.7489 12.7357 16.2598 12.7357Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5013 11.6542L15.6629 10.8211L16.8245 11.6703L16.3919 10.3004L17.5535 9.45927L16.1195 9.45126L15.6789 8.08942L15.2263 9.44726L13.7964 9.44325L14.9459 10.2924L14.5013 11.6542Z",
				fill: "#C4111B"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1683_4550",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 10,
			fill: "white"
		})
	}) })]
});
export default SvgWesternSahara;
